import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _KeyIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M18 8C18 8.69036 17.4404 9.25 16.75 9.25C16.0596 9.25 15.5 8.69036 15.5 8C15.5 7.30964 16.0596 6.75 16.75 6.75C17.4404 6.75 18 7.30964 18 8Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8488 2.54113C16.8622 2.15176 15.8062 1.96904 14.7462 2.00428C10.5928 2.13715 7.25071 5.58384 7.25 9.74023V9.74156H8.25L7.25 9.7389L7.25 9.74023C7.24809 10.508 7.36072 11.2704 7.58309 12.0027L2.51188 17.0739C2.18431 17.4018 2.00021 17.8468 2 18.3103V21C2 21.4641 2.18437 21.9092 2.51256 22.2374C2.84075 22.5656 3.28587 22.75 3.75 22.75H6.75C7.30228 22.75 7.75 22.3023 7.75 21.75V20.5H9C9.55228 20.5 10 20.0523 10 19.5V18.25H11.25C11.5152 18.25 11.7696 18.1446 11.9571 17.9571L12.7473 17.1669C13.4795 17.3893 14.2419 17.5019 15.0096 17.5H15.0084V16.5L15.0111 17.5L15.0096 17.5C19.1665 17.4994 22.6127 14.1567 22.7495 10.004C22.7842 8.94373 22.601 7.88758 22.211 6.90099C21.821 5.91441 21.2326 5.01839 20.4822 4.26845C19.7319 3.5185 18.8356 2.93059 17.8488 2.54113ZM14.8121 4.00319C15.5987 3.97697 16.3824 4.11253 17.1145 4.40149C17.8467 4.69044 18.5117 5.12663 19.0684 5.68304C19.6251 6.23945 20.0617 6.90424 20.351 7.63622C20.6403 8.36816 20.7763 9.1517 20.7505 9.93833C20.6492 13.0152 18.0848 15.5 15.0084 15.5L15.0058 15.5C14.2698 15.502 13.5404 15.3619 12.8576 15.0874C12.4859 14.938 12.0609 15.0249 11.7776 15.3082L10.8358 16.25H9C8.44772 16.25 8 16.6977 8 17.25V18.5H6.75C6.19772 18.5 5.75 18.9477 5.75 19.5V20.75H4V18.4142L9.44179 12.9724C9.72508 12.6891 9.81195 12.2641 9.66256 11.8924C9.38812 11.2095 9.24804 10.4802 9.25 9.74421L9.25 9.74156C9.25 6.66504 11.7347 4.10135 14.8106 4.00324L14.8121 4.00319Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const KeyIcon = assignWithoutSideEffects(_KeyIcon, {
  componentId: 'KeyIcon',
});

export default KeyIcon;
